<app-hero></app-hero>
<app-stats-bar></app-stats-bar>
<app-expertise></app-expertise>
<app-services></app-services>
<app-projects-gallery></app-projects-gallery>
<app-why-us></app-why-us>
<app-process-journey></app-process-journey>
<app-team-testimonials></app-team-testimonials>
<app-cta-banner></app-cta-banner>
